export enum ProjectAllowedAccess {
    Public = "Public",
    Private = "Private",
    Unknown = "Unknown",
    Other = "Other",
}
